module.exports = __webpack_public_path__ + "img/history-2020.50d692d2.jpg";